import request from "@/utils/request";

export async function all() {
  return await new Promise(resolve => {
    resolve({
      data: [],
    });
  });
  // return await request.get("/loyalty/deals", { data: null });
}
